import React, { useState, useRef } from "react";
import { Box, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { update_purchase_due_amount } from "../../Services/APIService";
import axios from "axios";
import SnackBar from "../../Components/AdminDashBoardComps/Snackbar";

const EditDue = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { purchaseList } = location.state || {}; // Access purchaseList from state

     const [open, setOpen] = useState(false);
      const [message, setMessage] = useState("");
      const [status, setStatus] = useState();
      const [color, setColor] = useState();
  const [editedPaidAmt, setEditedPaidAmt] = useState(purchaseList.paidAmount || 0);
  const [editedDue, setEditedDue] = useState(purchaseList.dueAmount || 0);
  

  const handleUpdateDueAmount = async () => {
    // Create a new FormData object
    const formData = new FormData();
    
    // Append data to the FormData object
    formData.append('purchaseId', purchaseList.purchaseId);
    formData.append('paidAmount', editedPaidAmt);
    formData.append('dueAmount', editedDue);
  
    try {
      // Send the FormData as POST request to your server
      const response = await axios.post(update_purchase_due_amount, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important to indicate you're sending form data
        },
      });
  
      // Handle the response here
      if (response.data.error) {
        setMessage(response.data.message);
        setOpen(true);
        setStatus(false);
        setColor(false);
      } else {
        setOpen(true);
        setMessage(response.data.message);
        setStatus(true);
        setColor(true);
        navigate('/dashbrdlayout/purchasedetails', { state: { id: purchaseList.purchaseId } });
      }
    } catch (error) {
      console.error('Error updating due amount:', error);
    }
  };
  

  return (
    <Box>
    
     
    <SnackBar
        open={open}
        setOpen={setOpen}
        status={status}
        color={color}
        message={message}
      />
        {/* Edit Payment Details Form */}
        <Box m={8}>
          <h3>Edit Due Details</h3>
          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            <label>
              Amount Paid ($):
              <input
                type="number"
                value={editedPaidAmt || ""}
                onChange={(e) => setEditedPaidAmt(Number(e.target.value) || 0)}
                style={{
                  padding: "8px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "100%",
                }}
              />
            </label>
            <label>
              Due Amount ($):
              <input
                type="number"
                value={editedDue !== undefined ? editedDue : ""}
                onChange={(e) => setEditedDue(Number(e.target.value) || 0)}
                style={{
                  padding: "8px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "100%",
                }}
              />
            </label>
            <Box display="flex" justifyContent={"center"} alignItems={"center"} gap={2} mt={3} >
            
              <Button onClick={handleUpdateDueAmount} color="primary" variant="contained">
                Save
              </Button>
            </Box>
          </Box>
        </Box>
     
    </Box>
  );
};


export default EditDue;